export default "__VITE_ASSET__Ca_foWsi__"